// extracted by mini-css-extract-plugin
module.exports = {"hr":"FanyForm_hr__aJO4E","termsWrapper":"FanyForm_termsWrapper__0q5XY"};